import { ArrowRight } from '@untitledui/icons';

import { ConnectHubspotButton } from '../ConnectHubspotButton';
import { HUBSPOT_IMPORT_INTENT, HUBSPOT_IMPORT_RETURN_TO } from './constants';

interface HubspotImportConnectStepProps {
  orgId: number;
}

const HUBSPOT_IMPORT_HEADING = 'Connect HubSpot to import';

const HUBSPOT_IMPORT_DESCRIPTION =
  'A one-time import of your HubSpot records into Ahoy. Review every field mapping before it runs – this does not set up ongoing two-way sync.';

const HUBSPOT_IMPORT_BENEFITS = [
  'Import your HubSpot contacts and companies into Ahoy',
  'Bring deals across with their pipelines and stages',
  'Review every field mapping before the import runs',
];

export function HubspotImportConnectStep({
  orgId,
}: HubspotImportConnectStepProps) {
  return (
    <div className='flex flex-col items-center'>
      <ConnectHubspotButton
        orgId={orgId}
        returnTo={HUBSPOT_IMPORT_RETURN_TO}
        intent={HUBSPOT_IMPORT_INTENT}
        heading={HUBSPOT_IMPORT_HEADING}
        description={HUBSPOT_IMPORT_DESCRIPTION}
        benefits={HUBSPOT_IMPORT_BENEFITS}
        connectorIcon={ArrowRight}
        connectorIconLabel='import'
      />
    </div>
  );
}
